import { Country, State } from 'country-state-city';

/** All countries sorted by name. */
export function getAllCountries() {
  return Country.getAllCountries()
    .map((c) => ({ value: c.isoCode, label: c.name }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

/** States/provinces for a country ISO code (empty array if none). */
export function getStatesForCountry(countryCode) {
  if (!countryCode) return [];
  return State.getStatesOfCountry(countryCode)
    .map((s) => ({ value: s.isoCode, label: s.name }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

export function getCountryLabel(isoCode) {
  if (!isoCode) return '';
  return Country.getCountryByCode(isoCode)?.name || isoCode;
}

export function getStateLabel(countryCode, stateCode) {
  if (!countryCode || !stateCode) return stateCode || '';
  const states = State.getStatesOfCountry(countryCode);
  const match = states.find((s) => s.isoCode === stateCode || s.name === stateCode);
  return match?.name || stateCode;
}

/** Resolve stored address label back to ISO code when editing. */
export function resolveCountryCode(stored) {
  if (!stored) return '';
  const byCode = Country.getCountryByCode(stored);
  if (byCode) return byCode.isoCode;
  const hit = Country.getAllCountries().find(
    (c) => c.name.toLowerCase() === String(stored).toLowerCase(),
  );
  return hit?.isoCode || stored;
}

export function resolveStateCode(countryCode, stored) {
  if (!stored) return '';
  const states = getStatesForCountry(countryCode);
  const byCode = states.find((s) => s.value === stored);
  if (byCode) return byCode.value;
  const byName = states.find((s) => s.label.toLowerCase() === String(stored).toLowerCase());
  return byName?.value || stored;
}
